import React from 'react';
import styled from 'styled-components';

const EmptyJobBlock = styled.div`
border-radius: 4px;
border: solid 1px ${props => props.theme.color.border};  
position: relative;
text-align: center;
height: calc(100% - 62px - 2em);
box-sizing: border-box;
margin-top: 1em;
display: flex;
align-items: center;
justify-content: center;
.empty-block-title {
  width: 100%;
  font-size: 18px;
  color: ${p => p.theme.color.label};
  margin-top: 25px;
}
`;


const EmptyJobs = (props) => {
  const { title } = props;

  return (
    <EmptyJobBlock className="empty-block">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="88" height="96" viewBox="0 0 88 96">
          <g fill="none" fillRule="evenodd">
            <path fill="#DBDCE1" fillRule="nonzero"
              d={`M56 24c6.8 0 12 5.2 12 12v20h8V36c0-9.6-7.2-18-16.4-19.6C58 7.2 49.6 0 
                40 0H0v96h52v-8H8V8h32c6.8 0 12 5.2 12 12v4h4zm-36 
                4v8h16v-8H20zm56 48V64h-8v12H56v8h12v12h8V84h12v-8H76zM20 52h40v-8H20v8z`} />
          </g>
        </svg>
        {title ? <p className="empty-block-title">{title}</p> : null}
      </div>
    </EmptyJobBlock>
  );
};

export default EmptyJobs;
